import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./context/AuthContext";
import { AnalyticsTracker } from "./lib/analytics";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import CompleteProfile from "./pages/CompleteProfile";
import Wizard from "./pages/Wizard";
import RoadmapPage from "./pages/RoadmapPage";
import Projects from "./pages/Projects";
import ProjectPage from "./pages/ProjectPage";
import SharePage from "./pages/SharePage";
import Admin from "./pages/Admin";
import Analyzer from "./pages/Analyzer";
import ApprovalsIndex from "./pages/explore/ApprovalsIndex";
import ApprovalDetail from "./pages/explore/ApprovalDetail";
import StatesIndex from "./pages/explore/StatesIndex";
import StateDetail from "./pages/explore/StateDetail";
import Glossary from "./pages/explore/Glossary";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
        <AnalyticsTracker />
        <Routes>
          <Route path="/share/:token" element={<SharePage />} />
          <Route path="*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/complete-profile" element={<CompleteProfile />} />
                <Route path="/wizard" element={<Wizard />} />
                <Route path="/analyzer" element={<Analyzer />} />
                <Route path="/roadmap/:runId" element={<RoadmapPage />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/projects/:projectId" element={<ProjectPage />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/approvals" element={<ApprovalsIndex />} />
                <Route path="/approvals/:slug" element={<ApprovalDetail />} />
                <Route path="/states" element={<StatesIndex />} />
                <Route path="/states/:slug" element={<StateDetail />} />
                <Route path="/glossary" element={<Glossary />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
          } />
        </Routes>
        <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
